import classes from "../../scss/WebDevelopment.module.scss";
import Hero from "../../components/Service/Hero";
import HeroTitle from "../../components/Service/HeroTitle";
import HeroText from "../../components/Service/HeroText";
import ContentContainer from "../../components/Service/ContentContainer";
import Wrapper from "../../components/Service/Wrapper";
import SectionText from "../../components/Service/SectionText";
import RequestDemo from "../../components/Button/RequestDemo";
import Section from "../../components/Service/Section";
import SectionTitle from "../../components/Service/SectionTitle";
import { data } from "../../data/webDevelopment";
import Description from "../../components/Service/Description";
import SectionList from "../../components/Service/SectionList";
import CollapsibleList from "../../components/Service/CollapsibleList";

const WebDevelopment = () => {
  return (
    <Wrapper className={classes.webDevelopment}>
      <Hero className={classes.hero}>
        <ContentContainer>
          <div className={classes.hero__body}>
            <div className={classes.hero__slide}>
              <HeroTitle
                title={data.hero.title}
                className={classes.hero__title}
              />
              <HeroText text={data.hero.text} className={classes.hero__text} />

              <RequestDemo className={classes.hero__button} />
            </div>
            <div className={classes.hero__slide}>
              <div className={classes.hero__image}>
                <img
                  width="513"
                  height="498"
                  src={data.hero.image}
                  alt="web development"
                />
              </div>
            </div>
          </div>
        </ContentContainer>
      </Hero>

      <Description
        title={data.description.title}
        text={data.description.text}
      />

      <Section
        className={`${classes.section_list} ${classes.process}
      ${classes.process__collapsible_wrapper}`}
      >
        <CollapsibleList
          title={data.process.title}
          list={data.process.content}
          className={classes.process__collapsible}
        />
      </Section>

      <Section className={`${classes.section_list} ${classes.components}`}>
        <ContentContainer>
          <div className={classes.section_list__container}>
            <SectionTitle
              title={data.components.title}
              className={classes.section_list__title}
            />
            <SectionList
              className={`${classes.section_list__wrapper_list} ${classes.list}`}
              list={data.components.content}
            />
          </div>
        </ContentContainer>
      </Section>

      <Section className={`${classes.section_list} ${classes.predictable}`}>
        <ContentContainer>
          <div className={classes.section_list__container}>
            <SectionTitle
              title={data.predictable.title}
              className={classes.section_list__title}
            />
            <div className={classes.predictable__body}>
              <SectionList
                className={`${classes.section_list__wrapper_list} ${classes.list}`}
                list={data.predictable.content}
              />
              <div className={classes.predictable__image}>
                <img
                  width="700"
                  height="525"
                  src={data.predictable.image}
                  alt={data.predictable.title}
                />
              </div>
            </div>
          </div>
        </ContentContainer>
      </Section>

      <Section
        className={`${classes.section_list} ${classes.process} ${classes.process__list_wrapper}`}
      >
        <ContentContainer>
          <div className={classes.section_list__container}>
            <SectionTitle
              title={data.process.title}
              className={classes.section_list__title}
            />
            <SectionList
              className={`${classes.section_list__wrapper_list} ${classes.list}`}
              list={data.process.content}
            />
          </div>
        </ContentContainer>
      </Section>

      <Section className={classes.stack}>
        <ContentContainer>
          <SectionTitle
            title={data.stack.title}
            className={classes.section_list__title}
          />
          <div className={classes.stack__body}>
            <SectionText
              text={data.stack.content}
              className={classes.stack__text}
            />
            <div className={classes.stack__image}>
              <img
                width="292"
                height="365"
                src={data.stack.image}
                alt={data.stack.title}
              />
            </div>
          </div>
        </ContentContainer>
      </Section>

      <Section className={classes.choose}>
        <ContentContainer>
          <div className={classes.choose__body}>
            <SectionTitle
              title={data.whyChoose.title}
              className={classes.choose__title}
            />
            <div className={classes.choose__text}>
              <SectionText text={data.whyChoose.description} />
            </div>
          </div>
        </ContentContainer>
      </Section>
    </Wrapper>
  );
};

export default WebDevelopment;
